import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    addQueryParamsToExistingUrl,
    getAccessToken,
} from '@sxm-de/dev-kits/web-sdk/utils';

interface GetOAuthFinalRedirectUriFnPayload {
    clientId: string;
    scope: string;
    state: string;
    redirectUri: string;
    nonce: string;
    codeChallenge: string;
    codeChallengeMethod: string;
}

export type GetOAuthFinalRedirectUriFn = (
    payload: GetOAuthFinalRedirectUriFnPayload,
) => Promise<{ redirectUrl: string; authCode: string }>;

export function initGetOAuthFinalRedirectUriFn({
    dependencies,
}: DomainInitPayload): GetOAuthFinalRedirectUriFn {
    const { atlasSdk } = dependencies;
    return async (payload: GetOAuthFinalRedirectUriFnPayload) => {
        try {
            const code = (await atlasSdk.domains.user.oauthThirdParty({
                request: payload,
                accessToken: getAccessToken(),
            })) as unknown as Record<string, unknown>;
            const authCode = code['authCode'] as string;

            // TODO: add analytics as needed to capture that we generated an OAuth auth code

            return {
                authCode,
                redirectUrl: addQueryParamsToExistingUrl({
                    url: payload.redirectUri,
                    queryParams: {
                        code: authCode,
                        state: payload.state,
                    },
                }),
            };
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
